export const initialValues = {
  title: '',
  date_from: null,
  date_to: null,
  keep_enabled_until: null,
  // campaing
  agencies: [],
  clients_op: 'AND',
  clients: [],
  activities_op: 'AND',
  activities: [],
  types: [],
  // supplier
  providers: [],

  outlets_or_service_categories_op: 'AND',
  outlets_or_service_categories: [],
  // number: null,

  // type: null,
  // direction: null,

  managed_types: [],
  commission: [
    {
      target: '0.00',
      rate: '',
      current: true,
    },
  ],
};
